import { render, staticRenderFns } from "./RowInfoText.vue?vue&type=template&id=84135e1a&"
import script from "./RowInfoText.vue?vue&type=script&lang=js&"
export * from "./RowInfoText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports